import styled from 'react-emotion'
import * as React from 'react'
import Text from './Text'
import { colors } from './styleguide'
import { Row } from './Box'

const Dots = styled(Text)`
  color: ${colors.foreground};
  font-size: 3rem;
  line-height: 0rem;
  margin-top: -2rem;
`

const DotContainer = styled(Row)`
  overflow: hidden;
  min-height: 40px;
`

export default ({ centered, sm }) => (
  <DotContainer justify="start">
    <Dots centered={centered}>. . . {!sm ? '. . .' : ''}</Dots>
  </DotContainer>
)



// WEBPACK FOOTER //
// ../styleguide/src/DotDivider.jsx